import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PromotionType from './types/promotionType';
import CreateDiscountPromotionPage from './implementations/CreateDiscountPromotionPage';
import CreatePromoCodePromotionPage from './implementations/CreatePromoCodePromotionPage';
import CreateConditionalDiscountPromotionPage from './implementations/CreateConditionalDiscountPromotionPage';
import CreateCombinedDiscountPromotionPage from './implementations/CreateCombinedDiscountPromotionPage';

/**
 * Route: /promotions/create?type=0
 * Renders the appropriate create form by type. type=0 → discount.
 */
function CreatePromotionPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const typeId = typeParam !== null ? parseInt(typeParam, 10) : null;

  if (typeId === PromotionType.DISCOUNT) {
    return <CreateDiscountPromotionPage />;
  }

  if (typeId === PromotionType.PROMO_CODE) {
    return <CreatePromoCodePromotionPage />;
  }

  if (typeId === PromotionType.CONDITIONAL || typeId === PromotionType.CONDITIONAL_DISCOUNT) {
    return <CreateConditionalDiscountPromotionPage />;
  }

  if (typeId === PromotionType.COMBINED || typeId === PromotionType.COMBINED_DISCOUNT) {
    return <CreateCombinedDiscountPromotionPage />;
  }

  if (typeId !== null && !Number.isNaN(typeId)) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <p>Этот тип акции пока не поддерживается.</p>
        <button type="button" onClick={() => navigate('/promotions/choose')}>
          Выбрать другой тип
        </button>
      </div>
    );
  }

  navigate('/promotions/choose', { replace: true });
  return null;
}

export default CreatePromotionPage;
